import { render } from "./EmbedProjectsView.vue?vue&type=template&id=80569bd2"
import script from "./EmbedProjectsView.vue?vue&type=script&lang=js"
export * from "./EmbedProjectsView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/tools.planval.ch/tools.planval.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__